import {type ClassValue, clsx} from "clsx"
import {twMerge} from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export const unslugify = (text: string) => {
  return text
      .split('-') // Split the string by hyphens
      .map(word => word.charAt(0).toUpperCase() + word.slice(1)) // Capitalize the first letter of each word
      .join(' '); // Join them back together with spaces
};


export const formatHeightLabel = (label: string): string => {
  // Remove the "cm-hoehe" or "cm hoehe" suffix
  label = label.replace(/cm-hoehe|cm hoehe|cm-hoehe/i, " cm");

  // Handle ranges separated by a dash
  const parts = label.split('-');
  if (parts.length === 2) {
    return `${parts[0].trim()} - ${parts[1].trim()}`;
  }

  // Default case if none of the above apply
  return label;
};

// Utility function to format depth values
export const formatDepthLabel = (label: string): string => {
  // Remove the "cm-tiefe" or "cm tiefe" suffix
  label = label.replace(/cm-tiefe|cm tiefe|cm-tiefe/i, " cm");

  // Handle ranges separated by a dash
  const parts = label.split('-');
  if (parts.length === 2) {
    return `${parts[0].trim()} - ${parts[1].trim()} `;
  }

  // Default case if none of the above apply
  return label;
};

export const sortColors = (colors: Record<string, { label: string; value: string; color_code: string }>): { label: string; value: string; color_code: string }[] => {
  return Object.values(colors).sort((a, b) => a.label.localeCompare(b.label));
};
